export const scheduledPostTargetsKeys = {
  prefix: 'scheduledPostTargets',
  all: (workspaceId: number, scheduledPostId: number) =>
    [scheduledPostTargetsKeys.prefix, 'workspace', workspaceId, 'scheduledPost', scheduledPostId] as const,
  lists: (workspaceId: number, scheduledPostId: number) =>
    [...scheduledPostTargetsKeys.all(workspaceId, scheduledPostId), 'list'] as const,
  list: (workspaceId: number, scheduledPostId: number) =>
    [...scheduledPostTargetsKeys.lists(workspaceId, scheduledPostId)] as const,
  details: (workspaceId: number, scheduledPostId: number) =>
    [...scheduledPostTargetsKeys.all(workspaceId, scheduledPostId), 'detail'] as const,
  detail: (workspaceId: number, scheduledPostId: number, targetId: number) =>
    [...scheduledPostTargetsKeys.details(workspaceId, scheduledPostId), targetId] as const,
  create: (workspaceId: number, scheduledPostId: number) =>
    [...scheduledPostTargetsKeys.all(workspaceId, scheduledPostId), 'create'] as const,
  update: (workspaceId: number, scheduledPostId: number, targetId: number) =>
    [...scheduledPostTargetsKeys.detail(workspaceId, scheduledPostId, targetId), 'update'] as const,
  delete: (workspaceId: number, scheduledPostId: number, targetId: number) =>
    [...scheduledPostTargetsKeys.detail(workspaceId, scheduledPostId, targetId), 'delete'] as const,
}
